import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import TaskItem from './TaskItem';
import SubTaskItem from './SubTaskItem';
import UpcomingDates from '../UpcomingDates'; 
import InspectionStep from './Inspection/InspectionStep'; 
import TitleStep from './Title/TitleStep';
import AppraisalStep from './Appraisal/AppraisalStep';
import TerminateButton from '../TerminateButton';
import { useAuth } from '../../utils/AuthContext/AuthContext';
import config from '../../utils/config';
import './Task.css'; 
import { useNextSteps } from './NextStepsContext';

const TaskList = ({contracts, onTerminated}) => {
  const contract = contracts[0];
  const { user, token } = useAuth();
  const getUserId = (user) => user.id || user._id;
  const { nextStepsState, setNextStepsState, toggleMainStepCompletion, toggleSubStepCompletion, updateSubStep } = useNextSteps();
  const [expandedSteps, setExpandedSteps] = useState(Array(10).fill(false));
  const [selectedDetailOption, setSelectedDetailOption] = React.useState('next steps');

const tasks = [
    { 
        title: "Depost Earnest Money", 
        taskKey: "depositEarnestMoney", 
        subText: `$${contract?.data?.prices?.[0]?.earnestMoney} due per contract`, 
        due: `Deadline: ${contract?.data?.dateFields?.alternative_earnest_money_deadline?.dayOfWeek} ${" "} ${contract?.data?.dateFields?.alternative_earnest_money_deadline?.date}`, 
        subSteps: [ 
            {
                title: "Deposit Earnest Money", 
                // taskKey: "depositEarnestFurtherDetail",
                subText: [`Deposit your earnest money, payable by: ${contract?.data?.earnestMoneyPayable}`],
                taskKey: "depositedEarnestMoney",
                actionTexts: ["Complete"]
            },  
        ]  
    },
    { 
        title: "Connect with Lender", 
        taskKey: "lender", 
        subText: 'Send contract documents', 
        due: "Deadline: Send documents as soon as possible", 
        subSteps: [
            {
                title: "Review Loan Estimate", 
                taskKey: "reviewLoanEstimate",
                subText: ["Review the loan estimate provided by your lender."],
                actionTexts: ["Complete"]
            },
            {
                title: "Submit Lender Documents", 
                taskKey: "submitLenderDocuments",
                subText: ["Submit all required documents to your lender."],
                actionTexts: ["Complete"]
            },
        ] 
    },
    { 
        title: "Order Homeowners Insurance", 
        taskKey: "insurance", 
        subText: 'Provide policy to Lender', 
        due: "Deadline: Order before closing", 
        subSteps: [
              {
                title: <>Order Insurance <small>(Optional)</small></>,
                taskKey: "orderInsurance",
                subText: "Talk with a Shishito agent or your preferred agent to get a quote and order homeowner's insurance.",
                actionTexts: ["Complete", "Contact"]
              },
        ] 
    },
    { 
        },
    { 
        title: "Transfer Utilities & Mail", 
        taskKey: "utilities", 
        subText: 'Transfer for the day of closing unless otherwise agreed with seller', 
        due: "Deadline: Transfer before closing", 
        subSteps: [
              {
                title: <>Additional Information</>,
                taskKey: "utilitiesAdditionalInfo",
                subText: "Transfer utilities and mail to your name.",
                actionTexts: ["Complete"]
              },
        ] 
    },
    { 
        title: "Schedule Closing", 
        taskKey: "closing", 
        subText: 'Schedule closing with Title Co. ahead of time', 
        due: "Deadline: Schedule before closing", 
        subSteps: [
            {
                title: <>Closing</>,
                taskKey: "scheduleClosing",
                subText: "Schedule closing before the actual closing date. You will meet with the title company to sign all the documents.",
                actionTexts: ["Complete"]
              },
            ] 
    },
    { 
        title: "Final Walkthrough",
        taskKey: "walkthrough",  
        subText: 'Complete final walkthrough', 
        due: "Deadline: Schedule after repairs are done", 
        subSteps: [
            {
                title: <>Walkthrough</>,
                taskKey: "scheduleWalkthrough",
                subText: "Your final walkthrough should be done after the repairs are done and before closing.",
                actionTexts: ["Complete"]
              },
        ] 
    },
    { 
        title: "Closing Day", 
        taskKey: "closingDay", 
        subText: 'Closing!!', 
        due: `Closing: ${contract?.data?.dateFields?.closing_date?.date}`, 
        subSteps: [
            {
                title: <>Additional Information</>,
                taskKey: "closingDayAdditionalInfo",
                subText: "You will meet with the title company to sign all the documents and get the keys.",
                // actionTexts: ["Contact"]
              },
        ] 
    },
];

useEffect(() => {
    const userId = getUserId(user);
    if (userId) {
      fetch(`${config.apiBaseUrl}/nextsteps/${userId}`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
      })
        .then((response) => {
          if (!response.ok) {
            if (response.status === 404) {
              // Initialize with full state object
              return fetch(`${config.apiBaseUrl}/nextsteps/${userId}`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ nextsteps: nextStepsState }),
              });
            } else {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
          }
          return response.json();
        })
        .then((data) => {
          if (data.nextsteps) {
            setNextStepsState(data.nextsteps);
          }
        })
        .catch((error) => console.error(error));
    }
  }, [user.id, token, setNextStepsState]);
  

const toggleExpansion = (index) => {
    const newExpandedSteps = [...expandedSteps];
    newExpandedSteps[index] = !newExpandedSteps[index];
    setExpandedSteps(newExpandedSteps);
  };

  return (
    <div className="flex flex-col my-5 w-full px-4">
      <div className='flex flex-col mb-5 md:mb-8 gap-1'>
        <h1 className='text-black font-semibold text-[16px] md:text-[22px]'>Congratulations, {user.firstName}! </h1>
        <p className='text-black font-inter font-light text-[14px] md:text-[16px]'>You are under contract on {contract.data.address.street}</p>
        <div className='inline-flex gap-10 items-center align-middle'>
            <Link to={`https://app.shishito-re.com/contract/${contract.formId}`} className='text-shi-green text-[14px]'>View Contract →</Link>  
            {/* <div className='border border-slate-600 w-[1px] h-full'></div> */}
            <TerminateButton
                formId={contract._id}
                onTerminateSuccess={(data) => {
                    console.log('Contract terminated:');
                }}
                onTerminated={onTerminated} 
            /> 
        </div> 
      </div>
      <nav className="flex justify-start gap-4 items-center px-2 w-full text-zinc-500 mb-3">
        <button onClick={() => setSelectedDetailOption('next steps')} className={`pb-1.5 ${selectedDetailOption === 'next steps' ? 'border-b border-shi-green text-shi-green font-semibold' : ''}`}>Next Steps</button>
        <button onClick={() => setSelectedDetailOption('dates')} className={`pb-1.5 ${selectedDetailOption === 'dates' ? 'border-b border-shi-green text-shi-green font-semibold' : ''}`}>Dates & Deadlines</button>
      </nav>
  
      {selectedDetailOption === 'next steps' && (
        <>
          {tasks.slice(0, 2).map((task, index) => (
      <div key={index} className={`task-container ${expandedSteps[index] ? 'expanded' : ''} my-1 shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px]`}>
        <TaskItem
          number={index + 1}
          title={task.title}
          description={task.subText}
          due={task.due}
          taskKey={task.taskKey}
          subTaskKey={null}
          nextStepsState={nextStepsState}
          toggleCompletion={toggleMainStepCompletion}
          onCardClick={() => {
            if (task.subSteps && task.subSteps.length > 0) {
              toggleExpansion(index);
            }
          }}
          isExpanded={expandedSteps[index]}
        />
        {expandedSteps[index] && task.subSteps && task.subSteps.length > 0 && (
          <div className={`drawer ${expandedSteps[index] ? 'expanded' : ''}`}>
            {task.subSteps.map((subTask, subIndex) => (
              <div key={subIndex}>
                <SubTaskItem
                  number={`${index + 1}.${subIndex + 1}`}
                  title={subTask.title}
                  subText={subTask.subText}
                  actionTexts={subTask.actionTexts}
                  onToggle={() => toggleSubStepCompletion(task.taskKey, subTask.taskKey)}
                  isCompleted={nextStepsState[task.taskKey]?.subSteps?.[subTask.taskKey]?.completed}
                  isSchedule={subTask.taskKey === 'scheduleInspector'}
                  scheduleDate={nextStepsState[task.taskKey]?.subSteps?.[subTask.taskKey]?.scheduleDate}
                  onScheduleChange={(newDate) =>
                    updateSubStep(task.taskKey, subTask.taskKey, { scheduleDate: newDate })
                  }
                />
              </div>
            ))}
          </div>
        )}
      </div>
    ))}
<InspectionStep
      contract={contract}
      due={contract?.data?.dateFields?.inspection_objection_deadline?.date}
      expandedSteps={expandedSteps}
    />
<TitleStep
      contract={contract}
      due={contract?.data?.dateFields?.record_title_objection_deadline?.date}
      expandedSteps={expandedSteps}
    />
    {tasks.slice(2, 3).map((task, index) => (
      <div
        key={index + 3}
        className={`task-container ${expandedSteps[index + 3] ? 'expanded' : ''} my-1 shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px]`}
      >
        <TaskItem
          number={index + 5}
          title={task.title}
          description={task.subText}
          due={task.due}
          taskKey={task.taskKey}
          subTaskKey={null}
          nextStepsState={nextStepsState}
          toggleCompletion={toggleMainStepCompletion}
          onCardClick={() => {
            if (task.subSteps && task.subSteps.length > 0) {
              toggleExpansion(index + 2);
            }
          }}
          isExpanded={expandedSteps[index + 2]}
        />
        {expandedSteps[index + 2] && task.subSteps && task.subSteps.length > 0 && (
          <div className={`drawer ${expandedSteps[index + 2] ? 'expanded' : ''}`}>
            {task.subSteps.map((subTask, subIndex) => (
              <div key={subIndex}>
                <SubTaskItem
                  number={`${index + 5}.${subIndex + 1}`}
                  title={subTask.title}
                  subText={subTask.subText}
                  actionTexts={subTask.actionTexts}
                  onToggle={() => toggleSubStepCompletion(task.taskKey, subTask.taskKey)}
                  isCompleted={nextStepsState[task.taskKey]?.subSteps?.[subTask.taskKey]?.completed}
                  isSchedule={subTask.taskKey === 'scheduleInspector'}
                  scheduleDate={nextStepsState[task.taskKey]?.subSteps?.[subTask.taskKey]?.scheduleDate}
                  onScheduleChange={(newDate) =>
                    updateSubStep(task.taskKey, subTask.taskKey, { scheduleDate: newDate })
                  }
                />
              </div>
            ))}
          </div>
        )}
      </div>
    ))}
    <AppraisalStep
      contract={contract}
      due={contract?.data?.dateFields?.record_title_objection_deadline?.date}
      expandedSteps={expandedSteps}
    />
        {tasks.slice(4).map((task, index) => (
      <div
        key={index + 4}
        className={`task-container ${expandedSteps[index + 4] ? 'expanded' : ''} my-1 shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px]`}
      >
        <TaskItem
          number={index + 7}
          title={task.title}
          description={task.subText}
          due={task.due}
          taskKey={task.taskKey}
          subTaskKey={null}
          nextStepsState={nextStepsState}
          toggleCompletion={toggleMainStepCompletion}
          onCardClick={() => {
            if (task.subSteps && task.subSteps.length > 0) {
              toggleExpansion(index + 4);
            }
          }}
          isExpanded={expandedSteps[index + 4]}
        />
        {expandedSteps[index + 4] && task.subSteps && task.subSteps.length > 0 && (
          <div className={`drawer ${expandedSteps[index + 4] ? 'expanded' : ''}`}>
            {task.subSteps.map((subTask, subIndex) => (
              <div key={subIndex}>
                <SubTaskItem
                  number={`${index + 7}.${subIndex + 1}`}
                  title={subTask.title}
                  subText={subTask.subText}
                  actionTexts={subTask.actionTexts}
                  onToggle={() => toggleSubStepCompletion(task.taskKey, subTask.taskKey)}
                  isCompleted={nextStepsState[task.taskKey]?.subSteps?.[subTask.taskKey]?.completed}
                  isSchedule={subTask.taskKey === 'scheduleInspector'}
                  scheduleDate={nextStepsState[task.taskKey]?.subSteps?.[subTask.taskKey]?.scheduleDate}
                  onScheduleChange={(newDate) =>
                    updateSubStep(task.taskKey, subTask.taskKey, { scheduleDate: newDate })
                  }
                />
              </div>
            ))}
          </div>
        )}
      </div>
    ))}
  </>
)}
      {selectedDetailOption === 'dates' && (
        <div className='flex flex-wrap justify-center gap-4'>
          {contracts.map(contract => (
            <UpcomingDates key={contract._id} formData={contract} userId={user.id || user._id} />
          ))}
        </div>
      )}
    </div>
  );
}

export default TaskList;